import song1 from "./song1.jpg";
import song2 from "./song2.avif";
import song3 from "./song3.avif";
import song4 from "./song4.webp";
import song5 from "./song5.avif";
import song6 from "./song6.avif";
import song7 from "./song7.webp";
import song8 from "./song8.avif";
import song9 from "./song9.avif";
import song10 from "./song10.avif";
import song11 from "./song11.avif";
import song12 from "./song12.avif";
import song13 from "./song13.avif";
import song14 from "./song14.avif";
import song15 from "./song15.avif";
import song16 from "./song16.jpg";
import song17 from "./song17.jpg";
import song18 from "./song18.avif";
import song19 from "./song19.avif";
import song20 from "./song20.avif";
import song21 from "./song21.avif";
import song22 from "./song22.jpg";
import song23 from "./song23.avif";
import song24 from "./song24.avif";
import song25 from "./song25.avif";
import song26 from "./song26.avif";
import song27 from "./song27.avif";
import song28 from "./song28.avif";
import song29 from "./song29.avif";
import song30 from "./song30.avif";
import escSong1 from "./esc_img/01_Albania.jpg";
import escSong2 from "./esc_img/02_Armenia.jpg";
import escSong3 from "./esc_img/03_Australia.jpg";
import escSong4 from "./esc_img/04_Austria.jpg";
import escSong5 from "./esc_img/05_Azerbaijan.jpg";
import escSong6 from "./esc_img/06_Belgio.jpg";
import escSong7 from "./esc_img/07_Bulgaria.jpg";
import escSong8 from "./esc_img/08_Croazia.jpg";
import escSong9 from "./esc_img/09_Cipro.jpg";
import escSong10 from "./esc_img/10_RepCeca.jpg";
import escSong11 from "./esc_img/11_Danimarca.jpg";
import escSong12 from "./esc_img/12_Estonia.jpg";
import escSong13 from "./esc_img/13_Finlandia.jpg";
import escSong14 from "./esc_img/14_Francia.jpg";
import escSong15 from "./esc_img/15_Georgia.jpg";
import escSong16 from "./esc_img/16_Germania.jpg";
import escSong17 from "./esc_img/17_Grecia.jpg";
import escSong18 from "./esc_img/18_Israele.jpg";
import escSong19 from "./esc_img/19_Italia.jpg";
import escSong20 from "./esc_img/20_Lettonia.jpg";
import escSong21 from "./esc_img/21_Lituania.jpg";
import escSong22 from "./esc_img/22_Lussemburgo.jpg";
import escSong23 from "./esc_img/23_Malta.jpg";
import escSong24 from "./esc_img/24_Moldavia.jpg";
import escSong25 from "./esc_img/25_Montenegro.jpg";
import escSong26 from "./esc_img/26_Norvegia.jpg";
import escSong27 from "./esc_img/27_Polonia.jpg";
import escSong28 from "./esc_img/28_Portogallo.jpg";
import escSong29 from "./esc_img/29_Romania.jpg";
import escSong30 from "./esc_img/30_SanMarino.jpg";
import escSong31 from "./esc_img/31_Serbia.jpg";
import escSong32 from "./esc_img/32_Svezia.jpg";
import escSong33 from "./esc_img/33_Svizzera.jpg";
import escSong34 from "./esc_img/34_Ucraina.jpg";
import escSong35 from "./esc_img/35_RegnoUnito.jpg";

export const artistImages = {
  song1,
  song2,
  song3,
  song4,
  song5,
  song6,
  song7,
  song8,
  song9,
  song10,
  song11,
  song12,
  song13,
  song14,
  song15,
  song16,
  song17,
  song18,
  song19,
  song20,
  song21,
  song22,
  song23,
  song24,
  song25,
  song26,
  song27,
  song28,
  song29,
  song30,
};

export const eurovisionArtistImages = {
  song1: escSong1,
  song2: escSong2,
  song3: escSong3,
  song4: escSong4,
  song5: escSong5,
  song6: escSong6,
  song7: escSong7,
  song8: escSong8,
  song9: escSong9,
  song10: escSong10,
  song11: escSong11,
  song12: escSong12,
  song13: escSong13,
  song14: escSong14,
  song15: escSong15,
  song16: escSong16,
  song17: escSong17,
  song18: escSong18,
  song19: escSong19,
  song20: escSong20,
  song21: escSong21,
  song22: escSong22,
  song23: escSong23,
  song24: escSong24,
  song25: escSong25,
  song26: escSong26,
  song27: escSong27,
  song28: escSong28,
  song29: escSong29,
  song30: escSong30,
  song31: escSong31,
  song32: escSong32,
  song33: escSong33,
  song34: escSong34,
  song35: escSong35,
};
